// import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
//import 'react-app-polyfill/stable';
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Link, useLocation } from "react-router-dom";
import { ThreeDots } from './ThreeDots';
import './DplayActivate.css';
import Axios from 'axios';
import { Button } from '@material-ui/core';

//const apiEndpoint ='https://partner.sappa.se/api/dplay/activationlink';

const ActivateCMore = async () => {

  //   fetch(apiEndpoint,{headers:{Authorization: '2D6AC8CF-7D30-4963-B429-09459CA23D81'}})
  //       .then(response => response.text())
  //       .then(data => window.location.href =data);

  window.location.href = "https://login.cmore.se/operator"; //https://activate.cmore.se/login/operator

}

function CMoreActivate(props) {

  useEffect(() => {
    setTimeout(() => {
      ActivateCMore();
    }, 5000);
  });

  return (
    <div className="container">

      <header className="App-header">
        <img src={require('./images/Sappa_Green.png')} />

        {/* <div style={{backgroundColor: 'red', color:'white', margin:'30px' }}>Just nu är det problem hos C More att aktivera abonnemang!</div> */}
        <p>
          Startar aktiveringsprocess av C More...
        </p>
        <ThreeDots color="#000000" height={150} width={150} />
        <img src={require('./images/CMoreLogoNew.jpg')} />
      </header>

    </div>
  );
}

export default CMoreActivate;
